package com.kaihuoy.components.common

import androidx.compose.runtime.*
import com.kaihuoy.components.common.*
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.dom.*
import org.jetbrains.compose.web.css.*

@Composable
fun StyledInput(
    label: String,
    value: String,
    placeholder: String = "",
    onValueChange: (String) -> Unit
) {
    var isFocused by remember { mutableStateOf(false) }

    Div(attrs = { style { marginBottom(16.px) } }) {
        Label(attrs = {
            style {
                display(DisplayStyle.Block)
                fontWeight("500")
                marginBottom(6.px)
                color(if (isFocused) KaihuTheme.Primary else KaihuTheme.TextPrimary)
                fontSize(0.875.em)
                property("transition", "color 0.2s ease")
            }
        }) {
            Text(label)
        }

        Input(type = InputType.Text, attrs = {
            this.value(value)
            attr("placeholder", placeholder)
            onInput { onValueChange(it.value) }
            onFocusIn { isFocused = true }
            onFocusOut { isFocused = false }

            style {
                width(100.percent)
                padding(12.px, 16.px)
                borderRadius(8.px)
                property("border", "1px solid ${if (isFocused) KaihuTheme.Primary else KaihuTheme.Border}")
                outline("none")
                boxSizing("border-box")
                fontSize(1.em)
                backgroundColor(KaihuTheme.Surface)
                property("transition", "all 0.2s ease")
                property("box-shadow", if (isFocused) "0 0 0 3px rgba(37, 99, 235, 0.1)" else "none")

            if (isFocused) {
                    property("border-color", KaihuTheme.Primary)
                }
            }
        })
    }
}
@Composable
fun StyledLargeInput(
    label: String,
    value: String,
    placeholder: String = "",
    onValueChange: (String) -> Unit
) {
    var isFocused by remember { mutableStateOf(false) }
    var message by remember { mutableStateOf("") }

    Div(attrs = { style { marginBottom(16.px) } }) {
        Label(attrs = {
            style {
                display(DisplayStyle.Block)
                fontWeight("500")
                marginBottom(6.px)
                color(if (isFocused) KaihuTheme.Primary else KaihuTheme.TextPrimary)
                fontSize(0.875.em)
                property("transition", "color 0.2s ease")
            }
        }) {
            Text(label)
        }

        TextArea(value, attrs = {
            this.value(value)
            attr("placeholder", placeholder)
            onInput { onValueChange(it.value) }
            onFocusIn { isFocused = true }
            onFocusOut { isFocused = false }

            style {

                /* width(100.percent)
                minHeight(180.px)
                padding(14.px, 16.px)
                borderRadius(14.px)
                border(1.px, LineStyle.Solid, KaihuTheme.Border)
                fontSize(1.em)
                fontFamily("inherit")
                property("resize", "vertical")
                boxSizing("border-box")
                color(KaihuTheme.TextPrimary)
                */

                width(100.percent)
                padding(12.px, 16.px)
                borderRadius(8.px)
                property("border", "1px solid ${if (isFocused) KaihuTheme.Primary else KaihuTheme.Border}")
                property("resize", "vertical")
                outline("none")
                boxSizing("border-box")
                fontSize(1.em)
                backgroundColor(KaihuTheme.Surface)
                property("transition", "all 0.2s ease")
                property("box-shadow", if (isFocused) "0 0 0 3px rgba(37, 99, 235, 0.1)" else "none")

                if (isFocused) {
                    property("border-color", KaihuTheme.Primary)
                }
            }
        })
    }
}
@Composable
fun StyledDateInput(
    label: String,
    value: String,
    placeholder: String = "PP.KK.VVVV",
    onValueChange: (String) -> Unit
) {
    var isFocused by remember { mutableStateOf(false) }

    Div(attrs = { style { marginBottom(16.px) } }) {
        Label(attrs = {
            style {
                display(DisplayStyle.Block)
                fontWeight("500")
                marginBottom(6.px)
                color(if (isFocused) KaihuTheme.Primary else KaihuTheme.TextPrimary)
                fontSize(0.875.em)
                property("transition", "color 0.2s ease")
            }
        }) {
            Text(label)
        }

        Input(type = InputType.Text, attrs = {
            this.value(value)
            attr("placeholder", placeholder)
            
            onInput { event ->
                val input = event.value
                val oldInput = value
                
                // Vain numerot ja erottimet sallittuja
                var clean = input.filter { it.isDigit() || it == '.' || it == '/' }
                
                // Jos käyttäjä poistaa merkkejä, älä yritä muotoilla uudelleen
                if (clean.length < oldInput.length) {
                    onValueChange(clean)
                    return@onInput
                }

                // Poistetaan pisteet/kauttaviivat hetkeksi, jotta voidaan analysoida numerot
                val numbersOnly = clean.filter { it.isDigit() }
                
                val formatted = when {
                    // Jos ekana kirjoitetaan 4-9 -> 04, 05 jne.
                    numbersOnly.length == 1 && numbersOnly[0].digitToInt() in 4..9 -> {
                        "0${numbersOnly[0]}."
                    }
                    // Jos päivä (2 numeroa) valmis -> lisää piste
                    numbersOnly.length == 2 && !clean.contains('.') -> {
                        "${numbersOnly.substring(0, 2)}."
                    }
                    // Jos kuukauden ensimmäinen numero on 4-9 -> 04, 05 jne.
                    numbersOnly.length == 3 && numbersOnly[2].digitToInt() in 2..9 -> {
                        "${numbersOnly.substring(0, 2)}.0${numbersOnly[2]}."
                    }
                    // Jos kuukausi (2 numeroa) valmis -> lisää piste
                    numbersOnly.length == 4 && clean.count { it == '.' } < 2 -> {
                        "${numbersOnly.substring(0, 2)}.${numbersOnly.substring(2, 4)}."
                    }
                    // Vuosi max 4 numeroa
                    numbersOnly.length > 8 -> {
                        clean.substring(0, 10)
                    }
                    else -> clean
                }

                onValueChange(formatted)
            }
            
            onFocusIn { isFocused = true }
            onFocusOut { isFocused = false }

            style {
                width(100.percent)
                padding(12.px, 16.px)
                borderRadius(8.px)
                property("border", "1px solid ${if (isFocused) KaihuTheme.Primary else KaihuTheme.Border}")
                outline("none")
                boxSizing("border-box")
                fontSize(1.em)
                backgroundColor(KaihuTheme.Surface)
                property("transition", "all 0.2s ease")
                property("box-shadow", if (isFocused) "0 0 0 3px rgba(37, 99, 235, 0.1)" else "none")

                if (isFocused) {
                    property("border-color", KaihuTheme.Primary)
                }
            }
        })
    }
}

@Composable
fun StyledMonthYearInput(
    label: String,
    value: String,
    placeholder: String = "KK/VV",
    onValueChange: (String) -> Unit
) {
    var isFocused by remember { mutableStateOf(false) }

    Div(attrs = { style { marginBottom(16.px) } }) {
        Label(attrs = {
            style {
                display(DisplayStyle.Block)
                fontWeight("500")
                marginBottom(6.px)
                color(if (isFocused) KaihuTheme.Primary else KaihuTheme.TextPrimary)
                fontSize(0.875.em)
                property("transition", "color 0.2s ease")
            }
        }) {
            Text(label)
        }

        Input(type = InputType.Text, attrs = {
            this.value(value)
            attr("placeholder", placeholder)
            
            onInput { event ->
                val input = event.value
                val oldInput = value
                
                // Vain numerot ja erottimet sallittuja
                var clean = input.filter { it.isDigit() || it == '/' }
                
                // Jos käyttäjä poistaa merkkejä, älä yritä muotoilla uudelleen
                if (clean.length < oldInput.length) {
                    onValueChange(clean)
                    return@onInput
                }

                // Poistetaan kauttaviivat hetkeksi, jotta voidaan analysoida numerot
                val numbersOnly = clean.filter { it.isDigit() }
                
                val formatted = when {
                    // Jos ekana kirjoitetaan 2-9 -> 02, 03 jne. (kuukausi max 12)
                    numbersOnly.length == 1 && numbersOnly[0].digitToInt() in 2..9 -> {
                        "0${numbersOnly[0]}/"
                    }
                    // Jos kuukausi (2 numeroa) valmis -> lisää kauttaviiva
                    numbersOnly.length == 2 && !clean.contains('/') -> {
                        val month = numbersOnly.substring(0, 2).toIntOrNull() ?: 0
                        if (month > 12) "12/" else "${numbersOnly.substring(0, 2)}/"
                    }
                    // Jos pituus ylittää KK/VV (4 numeroa)
                    numbersOnly.length > 4 -> {
                        val m = numbersOnly.substring(0, 2)
                        val y = numbersOnly.substring(2, 4)
                        "$m/$y"
                    }
                    else -> clean
                }

                onValueChange(formatted)
            }
            
            onFocusIn { isFocused = true }
            onFocusOut { isFocused = false }

            style {
                width(100.percent)
                padding(12.px, 16.px)
                borderRadius(8.px)
                property("border", "1px solid ${if (isFocused) KaihuTheme.Primary else KaihuTheme.Border}")
                outline("none")
                boxSizing("border-box")
                fontSize(1.em)
                backgroundColor(KaihuTheme.Surface)
                property("transition", "all 0.2s ease")
                property("box-shadow", if (isFocused) "0 0 0 3px rgba(37, 99, 235, 0.1)" else "none")

                if (isFocused) {
                    property("border-color", KaihuTheme.Primary)
                }
            }
        })
    }
}